const questions = [
  {
    id: 1,
    title: "Do you offer a free, no obligation quotation?",
    info: "Of course. We are more than happy to visit your property at a time convenient for yourself and quote for the required works. If you don’t own the property and are looking for us to quote on work for a property you are looking at purchasing, this is chargeable with a fixed cost.",
  },
  {
    id: 2,
    title:
      "We are/I Am looking to have an extension built and need advice on handling our application with the council, can you help guide us as part of your service?",
    info: "Yes. we have an excellent relationship with the City Council in which he is held in the highest regard by multiple building control personnel. Please look at our job photographs to see why.",
  },
  {
    id: 3,
    title:
      "Can you source all required materials and project manage our required works?",
    info: "Yes. The vast majority of our jobs include us sourcing all materials, handling all personnel and ensuring the project is completed to the highest standard. This is inclusive in our service. Our experience has shown that customers who attempt to project manage multiple tradesman and sourcing materials themselves more often than not turns into a false economy with no savings and increased overall costs. You will have a much better experience contracting a company to complete your project from start to finish.",
  },
  {
    id: 4,
    title:
      "Would we/I be able to view previous construction projects of similar size and requirements?",
    info: "Yes. We do with this most prospective customers. During the time frame of a project being completed, we build excellent relationships with our customers. They are usually delighted to show you the projects/work we have completed for them.",
  },
];

export default questions;
